import React, { useEffect } from 'react';
import PnlByAttributionChart from '../PortfolioLevelPnlChart/PnlByAttributionChart';
import { ICurrencyFormatter } from '../../../../../../../../services/selectors/portfolio';
import { LineData } from '../../../../../../../../models/LineData';
import useApi from '../../../../../../../../services/hooks/useApi';
import { getApiUrl } from '../../../../../../../../services/constants/endpoints';
import { PeriodHelper } from '../../../../../../../../services/utils/PeriodHelper';
// import { ASSETS, DetalizationType } from '../../../../../../../../services/constants/constants';
import { Loader } from '../../../../../../../../components';
import { useCustodiansFilter } from '../../../../../../../../services/hooks/useCustodiansFilter';

interface IProps {
  viewPositionHistory?(dateString: string): void;
  hideIncome?: boolean;
  portfolioCurrencyFormatter: ICurrencyFormatter;
  period: IPeriod;
  portfolioId: string;
  assetClassId?: string;
  changePerformancePeriod?: (period: IPeriod) => void;
  indexName?: string;
  indexPerformance?: LineData;
  hidePeriodSelector?: boolean;
}

const PnlByAttributionChartContainer = ({
  indexPerformance,
  indexName,
  changePerformancePeriod,
  period,
  portfolioCurrencyFormatter,
  viewPositionHistory,
  hideIncome,
  portfolioId,
  hidePeriodSelector,
  assetClassId,
}: IProps) => {
  /* const portfolioPerformance = useApi(getApiUrl('portfolio.performance'), {
    method: 'POST',
    data: {
      portfolioId,
      period: PeriodHelper.preparePeriodForRequest(period),
      detalization: DetalizationType.Daily,
      custodians: [],
    },
  }); */
  const { selectedCustodiansArray } = useCustodiansFilter();
  const noCustodians = !!assetClassId;
  const portfolioPnlByAttribution = useApi(getApiUrl('portfolio.profit.pnlByAttribution'), {
    method: 'POST',
    data: {
      portfolioId,
      assetClassId,
      period: PeriodHelper.preparePeriodForRequest(period),
      custodians: noCustodians ? [] : selectedCustodiansArray,
    },
  });

  useEffect(() => {
    portfolioPnlByAttribution.refetch();
  }, [period]);

  const isFetched = portfolioPnlByAttribution.isFetched;

  if (!isFetched) {
    return <Loader />;
  }

  return (
    <PnlByAttributionChart
      hideIncome={hideIncome}
      hidePeriodSelector={hidePeriodSelector}
      selectedPeriod={period}
      onPeriodChange={changePerformancePeriod}
      isDataLoaded={portfolioPnlByAttribution.isFetched}
      chartData={portfolioPnlByAttribution.data}
      portfolioCurrencyFormatter={portfolioCurrencyFormatter}
      onItemClick={viewPositionHistory}
      indexPerformance={indexPerformance}
      indexName={indexName}
      portfolioPerformance={[] as LineData}
    />
  );
};

export default PnlByAttributionChartContainer;
